// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@sc/Overrides/Widgets/OrderHistory/SearchTextField";
import * as React from "react";
import { useEffect, useState } from "react";

export const orderTotalStyles: SearchTextFieldStyles = {};
const styles = orderTotalStyles;

const OrderHistorySearchFieldOrderTotal: React.FunctionComponent<WidgetProps> = () => {
    // XNG-Changes: Amount should be disabled until orderTotalOperator is selected
    const orderTotalOperator = useAppSelector(
        state => state.pages.orderHistory.incompleteGetOrdersParameter?.orderTotalOperator,
    );
    const [isDisabled, setIsDisabled] = useState<boolean>(false);

    useEffect(() => {
        setIsDisabled(!orderTotalOperator);
    }, [orderTotalOperator]);

    return (
        <SearchTextField
            testSelector="orderHistory_filterOrderTotal"
            styles={styles}
            parameterField="orderTotal"
            label="Amount"
            inputType="number"
            placeholder=""
            // XNG-Changes
            isDisabled={isDisabled}
            maxLength={10}
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchFieldOrderTotal,
    definition: {
        group: "Order History",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
        displayName: "Order Total",
    },
};

export default widgetModule;
